import { z } from 'zod';
export const StandardClauseField = {
    FULL_TITLE: 'full_title',
    SUMMARY: 'summary',
    FISCAL_NOTE: 'fiscal_note',
    RECOMMENDED_ACTION_TEXT: 'recommended_action_text',
};
export const legislativeTypeClauseCreateSchema = z.object({
    standardField: z.enum(StandardClauseField),
    label: z
        .string('Label is required')
        .trim()
        .min(1, 'Label is required')
        .max(250)
        .describe('Short human-readable name shown in the clause picker dropdown.'),
    value: z
        .string('Clause text is required')
        .min(1, 'Clause text is required')
        .describe('The clause text inserted into the standard field when selected. For "summary" and "recommended_action_text" clauses this is HTML (sanitized server-side); for all others it is plain text.'),
});
export const legislativeTypeClauseUpdateSchema = z.object({
    label: z
        .string('Label is required')
        .trim()
        .min(1, 'Label is required')
        .max(250)
        .describe('Short human-readable name shown in the clause picker dropdown.'),
    value: z
        .string('Clause text is required')
        .min(1, 'Clause text is required')
        .describe('The clause text inserted into the standard field when selected. For "summary" and "recommended_action_text" clauses this is HTML (sanitized server-side); for all others it is plain text.'),
});
export const legislativeTypeClauseBulkCreateSchema = z.object({
    clauses: z.array(legislativeTypeClauseCreateSchema).min(1).max(100),
});
export const legislativeTypeClauseBulkReorderSchema = z.object({
    clauses: z
        .array(z.object({
        id: z.number().int().positive(),
        orderById: z.number().int().min(1),
    }))
        .min(1)
        .max(500),
});
